// @flow
import { createSelector } from 'reselect';

import { selectFromConfig } from '@gandi/redux-config';
import { localeSelector } from '@gandi/translate';

import type { NavigationItems } from '../../../Layout/types';
import type { FullState } from '../../../types';

export const labels = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  zh: '中文',
  'zh-hant': '正體中文',
  'zh-hans': '简体中文',
  ja: '日本語',
  de: 'Deutsch',
};

export const selectAvailableLocales: (
  state: FullState,
) => Array<{ code: string, name: string, ... }> = createSelector(
  [selectFromConfig<Array<string>>('locales.available', [])],
  locales => {
    const orderedLocales = [...locales].sort();
    return orderedLocales.map(code => ({
      code,
      // $FlowFixMe[invalid-computed-prop]
      name: labels[code] || code.toUpperCase(),
    }));
  },
);

export const relocalizeUrl = (
  url: string,
  oldLocale: string,
  newLocale: string,
): string => {
  const regex = new RegExp(`/${oldLocale}/`, 'g');

  return url.replace(regex, `/${newLocale}/`);
};

export type Option = { text: string, value: string };

export const selectLocaleOptions: (state: FullState) => Array<Option> =
  createSelector([selectAvailableLocales], availableLocales =>
    availableLocales.map(({ code, name }) => ({
      text: name,
      value: code,
    })),
  );

export const selectLocaleItems: (
  state: FullState,
  currentURL: string,
) => NavigationItems = createSelector(
  [localeSelector, selectAvailableLocales, (_, currentURL) => currentURL],
  (currentLocale, availableLocales, currentURL) =>
    availableLocales.map(({ code, name }) => {
      const isCurrent = currentLocale === code;

      return {
        title: name,
        href: isCurrent
          ? undefined
          : relocalizeUrl(currentURL, currentLocale, code),
        active: isCurrent,
      };
    }),
);
